import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";
import { CssBaseline } from "@material-ui/core";
import { createTheme, StylesProvider } from "@material-ui/core/styles";
import { ThemeProvider } from "styled-components";
import ShowAlert from "./components/ShowAlert";
import PortalHead from "./components/Content/Head";
import { useGlobal } from "./contexts/globalContext";
import Loading from "./components/Loading";
import Themes from "./themes/themes";
import GlobalLoader from "./components/GlobalLoader";
import VoucherIdentificationGate from "./components/VoucherIdentificationGate";

function App() {
	const { brand } = useGlobal();

	return (
		<ThemeProvider theme={createTheme(Themes[brand])}>
			<StylesProvider injectFirst>
				<BrowserRouter>
					<PortalHead />
					<CssBaseline />
					<Loading />
					<GlobalLoader />
					<Routes />
					<VoucherIdentificationGate />
					<ShowAlert />
				</BrowserRouter>
			</StylesProvider>
		</ThemeProvider>
	);
}

export default App;
